var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"15","height":"24","viewBox":"0 0 15 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M13 2L3 12L13 22","stroke":"currentColor","stroke-width":"3"}})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/pages/events/components/icons/chevron-left.vue?vue&type=template&id=1e3cd3a4&
// module id = 1165
// module chunks = 0